import { render, staticRenderFns } from "./admindetective.vue?vue&type=template&id=344cd083&"
import script from "./admindetective.vue?vue&type=script&lang=js&"
export * from "./admindetective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../usr/local/lib/node_modules/@vue/cli-service-global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports